import { Box } from "@mui/material";
import SideNav from "./SideNav";
import { Outlet } from "react-router-dom";
import TopNav from "./TopNav";
import { DRAWER_WIDTH, TOP_NAV_HEIGHT } from "base/constant/ui";
import useBreakpoint from "base/hooks/useBreakpoint";
import { checkIsLoadedInIframe } from "base/utils";

const isLoadedInIframe = checkIsLoadedInIframe();
const PageLayout = () => {
  const { isGreaterThanMd } = useBreakpoint();
  const isGWDesktopScreen = isLoadedInIframe && isGreaterThanMd;
  const offsetHeight = isGWDesktopScreen ? 0 : TOP_NAV_HEIGHT;

  return (
    <>
      <SideNav />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          ml: `${isGreaterThanMd ? DRAWER_WIDTH : 0}px`,
          height: `calc(100vh - ${offsetHeight}px)`,
        }}
      >
        {isGWDesktopScreen ? null : <TopNav />}
        <Box
          className="scroll-box"
          sx={{
            px: 2,
            py: 1,
            height: "100%",
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </>
  );
};

export default PageLayout;
